import { createContext } from "react";
import type { FactsField, FactsItemField } from "../../lib/facts/types";
import { valueProblemSentence } from "../../lib/facts/words";

/**
 * The sentence a problem is said in beside its field, for the controls in `FactsControls.tsx`. Build
 * round 19 (2026-10-08): Petrovic's Fakta sheet and the client's Webbplatsens fakta draw the same
 * controls, and the client is never told about a schema, so its form provides its own words
 * (`app/routes/clientFacts/clientFactsWords.ts`). Without a provider the words are Petrovic's.
 *
 * Its own module, because a file of components that also exports a context loses fast refresh.
 */
export const ProblemSentence = createContext<(code: string, field?: FactsField | FactsItemField) => string>(
  valueProblemSentence
);
